import React from "react";
import UniversalWorklistLayout from "./components/UniversalWorklistLayout";

interface TrackingPageProps {}

const TrackingPage = (props: TrackingPageProps) => {
  return (
    <UniversalWorklistLayout>
      <div className="text-center py-5">
        <i className="ti ti-map-pin fs-48 text-muted mb-3 d-block"></i>
        <h4 className="text-muted mb-2">No Tracking Items</h4>
        <p className="text-muted">There are currently no items to track.</p>
      </div>
    </UniversalWorklistLayout>
  );
};

export default TrackingPage;
